var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      value: _vm.input,
      fancy: _vm.fancy,
      label: _vm.label,
      "input-delay": 500,
      items: _vm.fetchedItems,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      "item-click": _vm.onDossierClick,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ item }) {
          return [
            _c("div", [
              _vm._v(_vm._s(_vm.dossierToString(item.ID, item.Name))),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }